// src/store/modules/app.js
import {
  getViewData
} from '../../utils';
import {
  apiMyPages,
  apiAlbumSeries,
  apiImgNewHot,
  apiThumbUp,
  apiStampsDetail
} from '../../api/stamps';
import {
  APP_FAILURE,
  ALBUM_PAGES,
  ALBUM_SERIES
} from '../../config/mutation-types';

const state = {
  myPages: '',
  albumSeries:[],
}

const getters = {
  getterMyPages: state => state.myPages,
  getterAlbumSeries: state => state.albumSeries
};

const actions = {
  getMyPages({ commit }, options) {
    if (!window.navigator.onLine) {
      alt('似乎已断开与互联网的链接');
    } else {
      return apiMyPages(options.data ? options.data : {}).then((res) => {
        if (res.data.resultCode == 0) {
          commit(ALBUM_PAGES, res.data.data);
          if(res.data.data.list.length > 0){
            if(options.success)options.success()
          }else{
            commit(APP_FAILURE, {
              type: 'text',
              text: '没有相册'
            });
          }

        } else {
          commit(APP_FAILURE, {
            type: 'text',
            text: res.data.resultMsg
          });
        }
      }).catch((err) => {
        commit(APP_FAILURE, {
          text: err.data.resultMsg
        })
      });
    }
  },
  getAlbumSeries({ commit }, options={}) {
    if (!window.navigator.onLine) {
      alt('似乎已断开与互联网的链接');
    } else {
      return apiAlbumSeries(options.data).then((res) => {
        if (res.status == 200 && res.data && res.data.resultCode == 0) {
          commit(ALBUM_SERIES, res.data.data);
          options.success()
        } else {
          commit(APP_FAILURE, {
            type: 'text',
            text: res.data.resultMsg
          });
        }
      }).catch((err) => {
        commit(APP_FAILURE, {
          text: '获取邮册失败'
        })
      });
    }
  },
  getImgNewHot({ commit }, options={}) {
    if (!window.navigator.onLine) {
      alt('似乎已断开与互联网的链接');
    } else {
      return apiImgNewHot(options.data).then((res) => {
        if (res.status == 200 && res.data && res.data.resultCode == 0) {
          options.success(res.data.data)
        } else {
          commit(APP_FAILURE, {
            type: 'text',
            text: res.data.resultMsg
          });
        }
      }).catch((error) => {
        commit(APP_FAILURE, {
          text: error.data.resultMsg
        })
      });
    }
  },
  thumbUpRequest({ commit }, options={}) {
    if (!window.navigator.onLine) {
      alt('似乎已断开与互联网的链接');
    } else {
      return apiThumbUp(options.data).then((res) => {
        if (res.status == 200 && res.data && res.data.resultCode == 0) {
          if(options.success){options.success(res.data.data)}

          let msg = '';
          if(res.data.data.status == 'VALID'){
            msg = '点赞成功'
          }

          if(res.data.data.status == 'INVALID'){
            msg = '取消点赞成功'
          }

          commit(APP_FAILURE, {
            type: 'text',
            time:1000,
            text: msg
          });
        } else {
          commit(APP_FAILURE, {
            type: 'text',
            text: res.data.resultMsg
          });
        }
      }).catch((error) => {
        console.log(error)
        commit(APP_FAILURE, {
          type: 'text',
          text: error.data.resultMsg
        });
      });
    }
  },
  getStampsDetail({ commit }, options={}) {
    if (!window.navigator.onLine) {
      alt('似乎已断开与互联网的链接');
    } else {
      return apiStampsDetail(options.data).then((res) => {
        if (res.status == 200 && res.data && res.data.resultCode == 0) {
          options.success(res.data);
        } else {
          commit(APP_FAILURE, {
            type: 'text',
            text: res.data.resultMsg
          });
        }
      }).catch((error) => {
        commit(APP_FAILURE, {
          text: error.data.resultMsg
        })
      });
    }
  },
};

const mutations = {
  [ALBUM_PAGES](state, data) {
    state.myPages = data;
  },
  [ALBUM_SERIES](state, data) {
    state.albumSeries = data;
  },
};

export default {
  state,
  getters,
  actions,
  mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/stamps.js